/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import StatusHeader from '../../Reusable/StatusHeader';
import FilterHeader from '../../Reusable/FilterHeader/FilterHeader';
import ContentCardsContainer from '../../Reusable/ContentCards/ContentCardsContainer';
import { Grid } from '@mui/material';
import useDebounce from '../../../../../../../../components/Hooks/useDebounce';
import GlobalSearchList from '../../Reusable/GlobalSearchList';

const ContentSectionView = () =>
{
	const [ searchValue, setSearchValue ] = useState<string>('');
	const debouncedSearchValue = useDebounce(searchValue, 500);

	return (
		<Grid container minHeight={'90%'} flexDirection={'column'} display={'flex'} flex={'none'}>
			<StatusHeader searchValue={searchValue} setSearchValue={setSearchValue} />
			{!searchValue && <FilterHeader />}
			<Grid item container p={2}>
				{debouncedSearchValue.length > 0
					? <GlobalSearchList searchValue={debouncedSearchValue} />
					: <ContentCardsContainer StatusVisible={false} />
				}
			</Grid>
		</Grid>
	);
};

export default ContentSectionView;
